const dev = {
  domain: "http://localhost:9872",
  api_domain: "http://localhost:9872/api",
  env: "uat",
  wms_uploads_bucket: "magna-wms-uploads",
  wms_uploads_cdn: "https://d1osfq4ya4myls.cloudfront.net",
  netsuite_url: "https://5615243-sb1.app.netsuite.com"
};

const uat = {
  domain: "http://34.197.161.10:9872",
  api_domain: "http://34.197.161.10:9872/api",
  env: "uat",
  wms_uploads_bucket: "magna-wms-uploads",
  wms_uploads_cdn: "https://d1osfq4ya4myls.cloudfront.net",
  netsuite_url: "https://5615243-sb1.app.netsuite.com"
};

const uat1 = {
  domain: "https://wms-uat-api.magnarouting.com",
  api_domain: "https://wms-uat-api.magnarouting.com/api",
  env: "uat",
  wms_uploads_bucket: "magna-wms-uploads",
  wms_uploads_cdn: "https://d1osfq4ya4myls.cloudfront.net",
  netsuite_url: "https://5615243-sb1.app.netsuite.com"
};


const prod = {
  domain: "https://wms-uat-api.magnarouting.com",
  api_domain: "https://wms-uat-api.magnarouting.com/api",
  env: "uat",
  wms_uploads_bucket: "magna-wms-uploads",
  wms_uploads_cdn: "https://d1osfq4ya4myls.cloudfront.net",
  netsuite_url: "https://5615243-sb1.app.netsuite.com"
};

module.exports = prod;